const ClientInfoTable = ({ clientInfo, onUpdateClick, onUnMapClick }) => {
  const { refNo, mobileNo, telecallerUserId, telecallerUserIdEditDate, stage } =
    clientInfo;

  const isEmpty = (val) => val == null || val === "";

  const restrictedStages = ["account opened", "application submitted"];
  const normalizedStage = stage?.toLowerCase();
  const isRestrictedStage = restrictedStages.includes(normalizedStage);

  const isUnmapDisabled =
    isEmpty(telecallerUserId) ||
    isEmpty(telecallerUserIdEditDate) ||
    isRestrictedStage;
  const isUpdateDisabled = isRestrictedStage;

  return (
    <div className="idu-table-container">
      <table className="idu-client-info-table w-100">
        <thead>
          <th>Client Reference number</th>
          <th>MOBILE NUMBER</th>
          <th>Telecaller User ID</th>
          <th>User ID EDIT DATE</th>
          <th>STAGE</th>
          <th>ACTION</th>
        </thead>

        <tbody>
          <td>{refNo || "-"}</td>
          <td>{mobileNo || "-"}</td>
          <td>{telecallerUserId || "-"}</td>
          <td>{telecallerUserIdEditDate || "-"}</td>
          <td>{stage || "-"}</td>
          <td className="action-buttons">
            <button
              className="idu-btn-primary"
              onClick={() => onUpdateClick(refNo)}
              disabled={isUpdateDisabled}
            >
              UPDATE
            </button>
            <button
              className="idu-btn-outline"
              onClick={() => onUnMapClick(refNo)}
              disabled={isUnmapDisabled}
            >
              UN-MAP
            </button>
          </td>
        </tbody>
      </table>
    </div>
  );
};

export default ClientInfoTable;
